module.exports = __webpack_public_path__ + "93bae885a97d358403c26500bf4372ea.svg";